import { ALERT_CHANNELS } from '../types/domain.types';
import type { AlertChannel, PasscodeChannel } from '../types/domain.types';

const NO_CHOICES: readonly AlertChannel[] = [];

const isAlertChannel = (channel: PasscodeChannel): channel is AlertChannel => (ALERT_CHANNELS as readonly string[]).includes(channel);

export const codeChoicesOf = (channels: readonly PasscodeChannel[] | null): readonly AlertChannel[] =>
  channels === null ? NO_CHOICES : channels.filter(isAlertChannel);

export type PhoneSendPair = readonly [AlertChannel, AlertChannel];

export const phoneChannelsLeadingWith = (first: AlertChannel): PhoneSendPair => [
  first,
  ALERT_CHANNELS.find((channel) => channel !== first) ?? first,
];
